// @ts-nocheck 5beba3f8
import * as actions from './logic/uploadedFontsActions';
import reducer from './uploadedFontsReducer';
import * as selectors from './uploadedFontsSelectors';

export { actions, reducer, selectors };
